export type AssignerBulkEntityType = 'recipe' | 'finishProduct' | 'supplement';
export type AssignerBulkTemplateFormat = 'csv' | 'xlsx';

export interface AssignerBulkLookupOption {
  id: string | number;
  name: string;
}

export interface AssignerBulkLookupMaps {
  sources?: AssignerBulkLookupOption[];
  dataSources?: AssignerBulkLookupOption[];
  databaseSources?: AssignerBulkLookupOption[];
  countries?: AssignerBulkLookupOption[];
}

export interface AssignerBulkPreviewColumn {
  key: string;
  label: string;
}

export interface AssignerBulkRowSelections {
  sourceId?: string | number | null;
  dataSourceId?: string | number | null;
  databaseSourceId?: string | number | null;
  countryOfOriginId?: string | number | null;
}

export interface AssignerBulkPreviewRow {
  rowNumber: number;
  valid: boolean;
  error?: string;
  /** Raw CSV cells keyed by normalized header */
  cells: Record<string, string>;
  /** Display fields for preview table */
  display: Record<string, string>;
  /** Dropdown selections (master ids) editable in preview */
  selections: AssignerBulkRowSelections;
  /** Payload fragment ready for create API (only when valid) */
  payload?: Record<string, unknown>;
}

export interface AssignerBulkParseResult {
  rows: AssignerBulkPreviewRow[];
  validCount: number;
  errorCount: number;
  totalCount: number;
  fileError?: string;
}

export const ASSIGNER_BULK_MAX_ROWS = 5000; // align with recipe/finish-product/supplement bulk-create cap

export const RECIPE_BULK_COLUMNS: AssignerBulkPreviewColumn[] = [
  { key: 'RecipeName', label: 'Recipe Name *' },
  { key: 'Source', label: 'Source *' },
  { key: 'Description', label: 'Description *' },
  { key: 'OriginalName', label: 'Alias' },
  { key: 'AlternateName', label: 'Alternate Name' },
];

export const PRODUCT_BULK_COLUMNS: AssignerBulkPreviewColumn[] = [
  { key: 'BrandName', label: 'Brand Name *' },
  { key: 'ProductName', label: 'Product Name *' },
  { key: 'DataSource', label: 'Data Source' },
  { key: 'DatabaseSource', label: 'Database Source' },
  { key: 'CountryOfOrigin', label: 'Country Of Origin' },
];

export const RECIPE_TEMPLATE_HEADERS = [
  'RecipeName',
  'Source',
  'Description',
  'OriginalName',
  'AlternateName',
];

export const PRODUCT_TEMPLATE_HEADERS = [
  'BrandName',
  'ProductName',
  'DataSource',
  'DatabaseSource',
  'CountryOfOrigin',
];
